import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { ContentService } from '../../services/content/content.service';
import { TranslateService } from '../../services/translate/translate.service';
import { marked } from 'marked';

@Pipe({ name: 'contentMountainRailwayNew' })
export class MountainRailwayNewPipe implements PipeTransform {
  constructor(private contentService: ContentService, private translate: TranslateService) {}

  transform(entry: Models.ContentEntry): Models.MountainRailwayEntryNew {
    if (!entry || !entry.detail) return null;

    const mountain = new Models.MountainRailwayEntryNew();
    mountain.populateFromJSON({ elements: [] });

    if (entry.detail.map) {
      let map = new Models.MountainRailwayContent();
      map.populateFromJSON({ type: 'map', path: entry.detail.map });
      mountain.elements.push(map);
    }

    const contentKeys = [
      { key: 'railways', type: 'railway' }, { key: 'slopes', type: 'slope' }, { key: 'trails', type: 'trail' },
      { key: 'hiking', type: 'hiking', extra: (item) => ({ classic: { total: item.total, open: item.open } }) }
    ];

    for (const { key, type, extra } of contentKeys) {
      if (entry.detail[key]) {
        const items = entry.detail[key].map((item) => ({ ...item, ...(extra ? extra(item) : {}) }));
        mountain.elements.push(this.createContent(type, items));
      }
    }

    for (const key of ['iceplace', 'curling', 'restaurant', 'sledge', 'park', 'snowshoe', 'other']) {
      const items = entry.detail[key] || entry.detail[key + 's'];
      if (items) mountain.elements.push(this.createContent(key, items));
    }

    if (entry.detail.waxtip) {
      const waxtip = new Models.MountainRailwayContent();
      const item = new Models.MountainRailwayContentItem();
      item.populateFromJSON({ title: entry.detail.title, raw: this.convertMarkdown(entry.detail.waxtip) })
      waxtip.populateFromJSON({ type: 'waxtip', items: [item] });
      mountain.elements.push(waxtip);
    }

    if (entry.detail.snowHeights) {
      const snowHeights = new Models.MountainRailwayContent();
      const item = new Models.MountainRailwayContentItem();
      item.populateFromJSON({ title: entry.detail.title, raw: entry.detail.snowHeights })
      snowHeights.populateFromJSON({ type: 'snowHeights', items: [item] });
      mountain.elements.push(snowHeights);
    }

    if (entry.detail.avalanche) {
      const avalanche = new Models.MountainRailwayContent();
      const items = entry.detail.avalanche.regions?.map(region => new Models.MountainRailwayContentItem().populateFromJSON({
        title: region.title, statusId: region.status
      })) || [];
      avalanche.populateFromJSON({ type: 'avalanche', path: entry.detail.avalanche.map || entry.detail.avalanche, items });
      mountain.elements.push(avalanche);
    }
    return mountain;
  }

  getTitle(item) {
    const title = item?.title || item?.name;
    return typeof title === 'string' ? title : title?.[this.translate.getCurrentLanguage()] || title?.[window['masterLanguage']] || '';
  }

  createContent(type: string, items: any[]) {
    const content = new Models.MountainRailwayContent();
    content.populateFromJSON({ type, items: [] });
    for (const item of items) {
      const mountainItem = new Models.MountainRailwayContentItem();
      mountainItem.populateFromJSON({
        title: this.getTitle(item), icon: item.icon || item.type, statusId: item.status, id: item.id, freeText: item.freeText,
        difficulty: item.difficulty, skating: item.skating, classic: item.classic, openingHours: item.openingHours
      });
      content.items.push(mountainItem);
    }
    return content;
  }

  convertMarkdown(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map((item) => this.convertMarkdown(item));
    }

    if (obj && typeof obj === 'object') {
      const newObj: any = {};
      const objType = obj['_type'];

      if (objType && 'ch_localeBlockContent' === objType) {
        for (const key in obj) {
          if (key === '_type') {
            newObj[key] = obj[key];
          } else if (typeof obj[key] === 'string') {
            newObj[key] = marked(obj[key].replace(/\n/g, '<br>'));
          } else {
            newObj[key] = obj[key];
          }
        }
      } else {
        for (const key in obj) {
          newObj[key] = this.convertMarkdown(obj[key]);
        }
      }

      return newObj;
    }

    return obj;
  }
}
